var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "650px",
    height: "350px",
    viewBox: "0 0 650 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-526.890013%",
    y1: "-4181.08808%",
    x2: "-526.890013%",
    y2: "-4168.31517%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0885E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066BC7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.4126967%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0366C2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_9",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    x: 440.067001,
    y: 280.198619,
    width: 79.1,
    height: 7.72,
    rx: 3.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_9",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    x: 129.067001,
    y: 280.198619,
    width: 79.1,
    height: 7.72,
    rx: 3.81
  }), /*#__PURE__*/React.createElement("text", {
    id: "OMINI",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    fontFamily: "ChalkboardSE-Regular, Chalkboard SE",
    fontSize: 180,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.8480663,
    y: 204
  }, "OMINI")), /*#__PURE__*/React.createElement("text", {
    id: "API",
    fontFamily: "Chalkboard",
    fontSize: 100,
    fontWeight: "normal",
    fill: "#2196F3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.19337,
    y: 322
  }, "API"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.24c295329bdd6217232b32a9cf035388.svg";
export { ForwardRef as ReactComponent };